import { IoInformationCircle, IoCheckmarkCircle, IoCloseCircle, IoWarning } from "react-icons/io5";

import "./Toast.scss";

const icons = {
  info: <IoInformationCircle className="toast__icon" />,
  success: <IoCheckmarkCircle className="toast__icon" />,
  error: <IoCloseCircle className="toast__icon" />,
  warning: <IoWarning className="toast__icon" />,
};

const Toast = ({ visible, message, type = "info" }) => {
  if (!visible) return null;

  return (
    <div className="toastWrapper">
      <div className={`toast toast--${type}`}>
        <div className="toast__icon-container">{icons[type]}</div>

        <div className="toast__message">{message}</div>
      </div>
    </div>
  );
};

export default Toast;
